import { SupplierModel } from '../admin/admin.types';

export interface UserModel {
  id: string;
  active: boolean;
  verified: boolean;
  email: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  username: string;
  usernameStatus: string;
  insertInstant: number;
  lastLoginInstant: number;
  roles: string[];
  seenNotifications: number[];
}

export interface LoginModel {
  token: string;
  user: UserModel;
  suppliers: SupplierModel[];
}


export enum UserRole {
  USER_MANAGE = 'USER_MANAGE',
  API_USER_MANAGE = 'API_USER_MANAGE',
  SETTINGS_VIEW = 'SETTINGS_VIEW0',
  SETTINGS_EDIT = 'SETTINGS_EDIT',
  SUPPLIER_MANAGE = 'SUPPLIER_MANAGE',
  FLEET_MANAGE = 'FLEET_MANAGE',
  FLEET_VIEW = 'FLEET_VIEW',
  DESK_MANAGE = 'DESK_MANAGE',
  DESK_VIEW = 'DESK_VIEW',
  BROKER_RATE_MANAGE = 'BROKER_RATE_MANAGE',
  RATE_MANAGE = 'RATE_MANAGE',
  PRODUCT_VIEW = 'PRODUCT_VIEW',
  ITEM_PRICE_VIEW = 'ITEM_PRICE_VIEW',
  STOP_SELL_MANAGE = 'STOP_SELL_MANAGE',
  STOP_SELL_VIEW = 'STOP_SELL_VIEW',
  CACHE_MANAGE = 'CACHE_MANAGE',
  RESERVATION_MANAGE = 'RESERVATION_MANAGE',
  RESERVATION_VIEW = 'RESERVATION_VIEW',
  RESERVATION_ACCEPT = 'RESERVATION_ACCEPT',
  RESERVATION_CANCEL = 'RESERVATION_CANCEL',
  SUPPLIER_WEBSITE_MANAGE = 'SUPPLIER_WEBSITE_MANAGE',
  BROKER = 'BROKER',
  BOOKING_MANAGER = 'BOOKING_MANAGER',
  RATES_MANAGER = 'RATES_MANAGER',
  SUPPLIER_ADMIN = 'SUPPLIER_ADMIN',
  RATE_CHAIN_SUPPORT = 'RATE_CHAIN_SUPPORT',
  RATE_CHAIN_ADMIN = 'RATE_CHAIN_ADMIN',
  HAS_DASHBOARD = 'HAS_DASHBOARD',
  HAS_PRICE_MONITORING = 'HAS_PRICE_MONITORING'
}

/*
* Users
*/

export interface CreateUserRequest {
  userPermissionGroupCode: UserGroupCode;
  supplierCodes: string[];
  user: UserRequest;
}

export interface UserRequest {
  email: string;
  username: string;
  password: string;
  firstName?: string;
  lastName?: string;
}

export interface UserResponse {
  email: string;
  username: string;
  firstName: string;
  lastName: string;
  lastLogin: string;
  suppliers: SupplierModel[];
  userPermissionGroupName: string;
  modifiedAt: string;
  modifiedBy: string;
}

export interface UserPermissionGroupModel {
  code: UserGroupCode;
  name: string;
}

export interface ListAllUsersResponse {
  total: number;
  users: UserResponse[];
}

export enum UserGroupCode {
  RC_SUPPORT = 'RC_SUPPORT',
  SUPPLIER_ADMIN = 'SUPPLIER_ADMIN',
  RATES_MANAGER = 'RATES_MANAGER',
  BOOKING_MANAGER = 'BOOKING_MANAGER',
  BROKER = 'BROKER',
  RC_ADMIN = 'RC_ADMIN',
}

export const UserGroupCodeOptions = [
  { value: UserGroupCode.RC_SUPPORT, label: 'RC SUPPORT' },
  { value: UserGroupCode.SUPPLIER_ADMIN, label: 'SUPPLIER ADMIN' },
  { value: UserGroupCode.RATES_MANAGER, label: 'RATES MANAGER' },
  { value: UserGroupCode.BOOKING_MANAGER, label: 'BOOKING MANAGER' },
  { value: UserGroupCode.BROKER, label: 'BROKER' },
  { value: UserGroupCode.RC_ADMIN, label: 'RC ADMIN' }
];

export const userViewRoles = [ UserRole.USER_MANAGE ];
export const userEditRoles = [ UserRole.USER_MANAGE ];

export interface ChangePasswordRequest {
  password: string;
}

export const dashboardViewRole = [ UserRole.HAS_DASHBOARD ];
export const priceMonitoringViewRole = [ UserRole.HAS_PRICE_MONITORING ];

export interface TableauTokenResponse {
  token: string;
}
